import { articleTrackLabel, articleUrl, border, ChevronLink, HELP_LIST_TRACK_CAT, hidden, LinkWithHelpHighlight, SearchBarContainer } from '../util';
import React from 'react';
import { ContentBody, ContentTitle } from './common';
import styled from 'styled-components';
import { IconChevronLeft, IconChevronRight, Type, screenMdMin, spacer24 } from '@spotify-internal/encore-web';
import { SearchBar } from '../../Search';
import { useT, useLocale } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BackButton = styled.div.withConfig({
  displayName: "HelpListCategory__BackButton",
  componentId: "sc-5wopx6-0"
})(["margin-bottom:", ";@media (min-width:", "){", "}"], spacer24, screenMdMin, hidden);
var Content = styled(ContentBody).withConfig({
  displayName: "HelpListCategory__Content",
  componentId: "sc-5wopx6-1"
})(["max-width:unset;"]); // it seems the li needs to be styled, or else the ul inside will have a strange error

var ArticleList = styled.ul.withConfig({
  displayName: "HelpListCategory__ArticleList",
  componentId: "sc-5wopx6-2"
})(["list-style:none;padding-left:0;"]);
var ArticleLinkContainer = styled.li.withConfig({
  displayName: "HelpListCategory__ArticleLinkContainer",
  componentId: "sc-5wopx6-3"
})(["", " padding:", " 0;&:last-child{border-bottom:none;@media (max-width:", "){", "}}@media (max-width:", "){&:first-child{", "}}"], border, spacer24, screenMdMin, border, screenMdMin, border);
var ArticleLink = styled(LinkWithHelpHighlight).withConfig({
  displayName: "HelpListCategory__ArticleLink",
  componentId: "sc-5wopx6-4"
})(["display:flex;flex-flow:row nowrap;justify-content:space-between;svg{min-width:", ";margin-left:", ";}"], spacer24, spacer24);
export var StyledIconChevronRight = styled(IconChevronRight).withConfig({
  displayName: "HelpListCategory__StyledIconChevronRight",
  componentId: "sc-5wopx6-5"
})(["align-self:center;"]);
var LinkText = styled(Type).attrs({
  as: Type.span,
  variant: Type.heading4
}).withConfig({
  displayName: "HelpListCategory__LinkText",
  componentId: "sc-5wopx6-6"
})([""]);
export var FaqCategoryView = function FaqCategoryView(_ref) {
  var category = _ref.category;
  var t = useT();
  var locale = useLocale();
  var filteredFaqs = !locale || locale === 'en' ? category === null || category === void 0 ? void 0 : category.faqs : category === null || category === void 0 ? void 0 : category.faqs.filter(function (i) {
    return i.translated;
  });
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(BackButton, {
      children: /*#__PURE__*/_jsx(ChevronLink, {
        "aria-label": t('FRODOR_CONTENT_BACK_BUTTON', 'Back', 'Back means previous in this case'),
        track: [HELP_LIST_TRACK_CAT, 'Back to Home'],
        href: "/help",
        children: /*#__PURE__*/_jsx(IconChevronLeft, {
          "aria-hidden": "true"
        })
      })
    }), /*#__PURE__*/_jsx(SearchBarContainer, {
      "data-testid": "help-search-bar",
      children: /*#__PURE__*/_jsx(SearchBar, {
        contentTypes: ['faq'],
        placeholder: t('FRODOR_e6f5ed', 'Search help articles', ''),
        suggestCount: 5,
        trackCategory: HELP_LIST_TRACK_CAT,
        getSuggestUrl: function getSuggestUrl(sug) {
          return "".concat(sug.url, "?ref=sug_").concat(HELP_LIST_TRACK_CAT).concat(category ? "&category=".concat(category.urlSlug) : '');
        }
      })
    }), /*#__PURE__*/_jsx(ContentTitle, {
      children: category === null || category === void 0 ? void 0 : category.name
    }), /*#__PURE__*/_jsx(ArticleList, {
      children: (filteredFaqs || []).map(function (article, i) {
        return /*#__PURE__*/_jsx(ArticleLinkContainer, {
          children: /*#__PURE__*/_jsxs(ArticleLink, {
            track: [HELP_LIST_TRACK_CAT, articleTrackLabel(article)],
            href: articleUrl(article, category),
            children: [/*#__PURE__*/_jsx(LinkText, {
              children: article.question
            }), /*#__PURE__*/_jsx(StyledIconChevronRight, {})]
          })
        }, i);
      })
    })]
  });
};